/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const sections = document.querySelectorAll( 'section[data-component]' );
      sections.forEach( ( section, index ) => {
        const currentBgColor = window.getComputedStyle( section ).backgroundColor;

        if ( index < sections.length - 1 ) {
          const nextBgColor = window.getComputedStyle( sections[index + 1] ).backgroundColor;

          if ( currentBgColor !== nextBgColor ) {
            section.style.borderBottom = '1px solid #3A3A3C';
          }
        }
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'component-borders', COMPONENT );
} )( app );
